import React from "react";
import { NavLink, DataTable, Button } from "../../components";
import { makeStyles } from "@material-ui/styles";
import Header from "./Header";
import sharedStyles, { dataTableStyles } from "../styles";
import { Helmet } from "react-helmet";
import AddIcon from "@material-ui/icons/Add";
import { useTaskDefs } from "../../data/task";
import { Tooltip } from "@material-ui/core";

const useStyles = makeStyles(sharedStyles);

const columns = [
  {
    name: "name",
    wrap: false,
    label: (
      <Tooltip title="Name">
        <div>Name</div>
      </Tooltip>
    ),
    renderer: (name) => (
      <Tooltip title={name}>
        <NavLink path={`/taskDef/${name}`}>{name}</NavLink>
      </Tooltip>
    ),
  },
  {
    name: "description",
    grow: 2,
    wrap: false,
    label: (
      <Tooltip title="Description">
        <div>Description</div>
      </Tooltip>
    ),
    renderer: (val) => (
      <Tooltip title={val}>
        <div>{val}</div>
      </Tooltip>
    ),
  },
  {
    name: "createTime",
    type: "date",
    wrap: false,
    label: (
      <Tooltip title="Create Time">
        <div>Create Time</div>
      </Tooltip>
    ),
  },
  {
    name: "ownerEmail",
    wrap: false,
    label: (
      <Tooltip title="Owner Email">
        <div>Owner Email</div>
      </Tooltip>
    ),
    renderer: (val) => (
      <Tooltip title={val}>
        <div>{val}</div>
      </Tooltip>
    ),
  },
  {
    name: "inputKeys",
    type: "json",
    sortable: false,

    wrap: false,
    label: (
      <Tooltip title="Input Keys">
        <div>Input Keys</div>
      </Tooltip>
    ),
  },
  {
    name: "outputKeys",
    type: "json",
    sortable: false,

    wrap: false,
    label: (
      <Tooltip title="Output Keys">
        <div>Output Keys</div>
      </Tooltip>
    ),
  },
  {
    name: "timeoutPolicy",
    grow: 0.5,
    wrap: false,
    label: (
      <Tooltip title="Timeout Policy">
        <div className="tooltip-label">Timeout Policy</div>
      </Tooltip>
    ),
    renderer: (val) => (
      <Tooltip title={val}>
        <div>{val}</div>
      </Tooltip>
    ),
  },
  {
    name: "timeoutSeconds",
    grow: 0.5,
    label: (
      <Tooltip title="Timeout Seconds">
        <div>Timeout Seconds</div>
      </Tooltip>
    ),
    renderer: (val) => (
      <Tooltip title={val}>
        <div>{val}</div>
      </Tooltip>
    ),
  },
  {
    name: "retryCount",
    grow: 0.5,
    label: (
      <Tooltip title="Retry Count">
        <div>Retry Count</div>
      </Tooltip>
    ),
    renderer: (val) => (
      <Tooltip title={val}>
        <div>{val}</div>
      </Tooltip>
    ),
  },
  {
    name: "retryLogic",
    label: (
      <Tooltip title="Retry Logic">
        <div>Retry Logic</div>
      </Tooltip>
    ),
    renderer: (val) => (
      <Tooltip title={val}>
        <div>{val}</div>
      </Tooltip>
    ),
  },
  {
    name: "retryDelaySeconds",
    grow: 0.5,
    label: (
      <Tooltip title="Retry Delay Seconds">
        <div>Retry Delay Seconds</div>
      </Tooltip>
    ),
    renderer: (val) => (
      <Tooltip title={val}>
        <div>{val}</div>
      </Tooltip>
    ),
  },
  {
    name: "responseTimeoutSeconds",
    grow: 0.5,
    label: (
      <Tooltip title="Response Timeout Seconds">
        <div>Response Timeout Seconds</div>
      </Tooltip>
    ),
    renderer: (val) => (
      <Tooltip title={val}>
        <div>{val}</div>
      </Tooltip>
    ),
  },
  {
    name: "inputTemplate",
    type: "json",
    sortable: false,
    label: (
      <Tooltip title="Input Template">
        <div>Input Template</div>
      </Tooltip>
    ),
  },
  {
    name: "rateLimitPerFrequency",
    grow: 0.5,
    label: (
      <Tooltip title="Rate Limit Per Frequency">
        <div>Rate Limit Per Frequency</div>
      </Tooltip>
    ),
    renderer: (val) => (
      <Tooltip title={val}>
        <div>{val}</div>
      </Tooltip>
    ),
  },
  {
    name: "rateLimitFrequencyInSeconds",
    grow: 0.5,
    label: (
      <Tooltip title="Rate Limit Frequency In Seconds">
        <div>Rate Limit Frequency In Seconds</div>
      </Tooltip>
    ),
    renderer: (val) => (
      <Tooltip title={val}>
        <div>{val}</div>
      </Tooltip>
    ),
  },
  {
    name: "name",
    label: "Executions",
    id: "executions_link",
    grow: 0.5,
    renderer: (name) => (
      <NavLink path={`/search/tasks?taskName=${name}`}>Query</NavLink>
    ),
    sortable: false,

    searchable: false,
  },
  {
    name: "concurrentExecLimit",
    label: (
      <Tooltip title="Concurrent Exec Limit">
        <div>Concurrent Exec Limit</div>
      </Tooltip>
    ),
    renderer: (val) => (
      <Tooltip title={val}>
        <div>{val}</div>
      </Tooltip>
    ),
  },
  {
    name: "pollTimeoutSeconds",
    label: (
      <Tooltip title="Poll Timeout Seconds">
        <div>Poll Timeout Seconds</div>
      </Tooltip>
    ),
    renderer: (val) => (
      <Tooltip title={val}>
        <div>{val}</div>
      </Tooltip>
    ),
  },
];

export default function TaskDefinitions(props) {
  const permissions = props?.permissions;
  const classes = useStyles();
  const { data: tasks, isFetching, refetch } = useTaskDefs();

  return (
    <div className={classes.wrapper}>
      <Helmet>
        <title>Conductor UI - Task Definitions</title>
      </Helmet>

      <Header tabIndex={1} loading={isFetching} permissions={permissions} />

      <div className={classes.tabContent}>

        {tasks && (
          <DataTable
            title={`${tasks.length} results`}
            localStorageKey="tasksTable"
            defaultShowColumns={[
              "name",
              "description",
              "ownerEmail",
              "timeoutPolicy",
              "retryCount",
              "executions_link",
            ]}
            keyField="name"
            default
            data={tasks}
            columns={columns}
            customStyles={dataTableStyles}
            fixedHeader
            fixedHeaderScrollHeight="calc( 100vh - 240px )"
            showRefresh = {true}
            handleRefreshClick = {() => {refetch()}}
            customBtn = {permissions?.tasks?.actions?.create_task ? {
              className : '',
              link: "/taskDef",
              btnText: "New Task Definition" 
            } : null}
          />
        )}
      </div>
    </div>
  );
}
